import groq from 'groq'
import { imageObject } from '../atoms/imageObject'
export const LogoGalleryQuery = groq`
    _type == 'LogoGallery' => {
    ...,
    images[]{

          ...,
           asset->{
            ...,
            _id,
            url,
            _type,
            altText,
            description,
            title,
              metadata {
                blurHash,
                dimensions,
              }
            }
    },
  }`
